import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { localize } from 'commons/LocalizedText/LocalizedText';
import { CustomTable } from 'commons/Table/CustomTable';
import { generateRow } from 'utils/helpers/RowHelper';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: '50px 0'
  },
  countryAutoComplete: {
    minWidth: '300px',
    margin: 0,
    '& .MuiTextField-root': {
      marginTop: 0
    }
  },
  generalPadding: {
    marginTop: theme.spacing(5)
  }
}));

export const ProductTestContactsPage = ({
  productTestContacts,
  isLoadingTestDetails
}) => {
  const classes = useStyles();

  const productTestContactRows = [
    generateRow({
      name: 'role',
      width: '5%',
      mobileWidth: '40%',
      isSortable: false,
      template: (row) => (
        <div>
          {localize(row?.role)}
        </div>
      )
    }),
    generateRow({
      name: 'firstName',
      width: '5%',
      mobileWidth: '40%',
      isSortable: false,
      template: (row) => (
        <div>
          {row?.firstName}
        </div>
      )
    }),
    generateRow({
      name: 'name',
      width: '5%',
      mobileWidth: '40%',
      isSortable: false,
      template: (row) => (
        <div>
          {row?.name}
        </div>
      )
    }),
    generateRow({
      name: 'email',
      width: '20%',
      mobileWidth: '40%',
      isSortable: false,
      template: (row) => (
        <div>
          {row?.email}
        </div>
      )
    }),
    generateRow({
      name: 'phoneNumber',
      width: '10%',
      mobileWidth: '40%',
      isSortable: false,
      template: (row) => (
        <div>
          {row?.phoneNumber}
        </div>
      )
    })
  ];

  return (
    <div className={classes.generalPadding}>
      <Grid className={classes.columnContainer} container direction='column' spacing={2}>
        <Grid item>
          <Grid alignitem='center' container direction='column' spacing={4}>
            <Grid item>
              <Grid container direction='column' spacing={2}>
                <Grid item>
                  <Grid container direction='column'>
                    <CustomTable
                      headers={productTestContactRows}
                      isBackend={false}
                      isLoading={isLoadingTestDetails}
                      needForFooter={false}
                      rowKey="contactsRows"
                      rows={productTestContacts}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};